import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import {
    MwSmallIcon,
    AutoDetectFixIssue,
    DeepVisibility,
    CorrelateInfraData
} from "../../components/v2/icons";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import Accordion from "../../components/v2/accordion/accordion";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import Link from "next/link";
import SupportK8sPlatforms from "../../components/v2/support-k8s-platforms";
import '../../styles/scss/_blog-section-k8s-monitoring.module.scss';
import '../../styles/scss/_faq-section.module.scss';

export default function KubernetesMonitoring() {
    const { t } = useTranslation("common");

    const featuresData = t("product.kubernetes-monitoring.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];

    const faqsData = t("product.kubernetes-monitoring.faq.questions", { returnObjects: true }) as any[];
    const faqs = Array.isArray(faqsData) ? faqsData : [];

    const resourcesData = t("product.kubernetes-monitoring.resources.items", { returnObjects: true }) as any[];
    const resources = Array.isArray(resourcesData) ? resourcesData : [];

    const whyUsCardsData = t("product.kubernetes-monitoring.whyUs.cards", { returnObjects: true }) as any[];
    const whyUsCards = Array.isArray(whyUsCardsData) ? whyUsCardsData : [];

    return (
        <>

            <ProductHeroSection
                title={
                    <h1>
                        <span>{t("product.kubernetes-monitoring.hero.title")}</span> {t("product.kubernetes-monitoring.hero.titleHighlight")}
                    </h1>
                }
                description={t("product.kubernetes-monitoring.hero.description")}
                img={"/images/product/kubernetes-monitoring.webp"} imgMobile={"/images/product/kubernetes-monitoring-mobile.webp"} preloadImg
                imgAlt={t("product.kubernetes-monitoring.hero.imgAlt")}
                hasActions={false}
                tips={t("product.hero.tips")}
                hasActionsDemo={true}
                hasActionsDocsLink="https://docs.middleware.io/agent-installation/kubernetes"
            />

            <FeaturesMonitoring productFeatures={features}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.kubernetes-monitoring.features.title"
                            components={{
                                highlight: <span className="text-gradient" />
                            }}
                        />
                    </h2>
                }
                tourId={""}
                className="kubernetes-features-product"
                isTryOut
            />

            <SupportK8sPlatforms />

            <section className={"move-to-middleware k8s-monitoring-page"}>
                <div className={"container"}>
                    <div className={"mw-feature"}>
                        <div className={"d-flex"}>
                            <div className={"left-block"}>
                                <div className={"left-sticky"}>
                                    <div className={"section-tag testimonial"}>
                                        <MwSmallIcon /> {t("product.kubernetes-monitoring.whyUs.tag")}
                                    </div>
                                    <h2>
                                        <Trans
                                            i18nKey="product.kubernetes-monitoring.whyUs.title"
                                            components={{
                                                highlight: <span className="text-gradient" />
                                            }}
                                        />
                                    </h2>
                                    <img
                                        src={"/images/product/k8s-platform-support.svg"}
                                        alt={t("product.kubernetes-monitoring.whyUs.imageAlt")}
                                        width={"200"}
                                        height={"200"}
                                    />
                                </div>
                            </div>
                            <div className={"right-block"}>
                                <div className={"view-card"}>
                                    <DeepVisibility />
                                    <h3>{whyUsCards[0]?.title}</h3>
                                    <p>
                                        {whyUsCards[0]?.description}
                                    </p>
                                </div>
                                <div className={"view-card"}>
                                    <AutoDetectFixIssue />
                                    <h3>{whyUsCards[1]?.title}</h3>
                                    <p>
                                        {whyUsCards[1]?.description}
                                    </p>
                                </div>
                                <div className={"view-card"}>
                                    <CorrelateInfraData />
                                    <h3>{whyUsCards[2]?.title}</h3>
                                    <p>
                                        {whyUsCards[2]?.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Testimonial className="arrow-top-right" />

            <div className="blog-section-k8s-monitoring-resources">
                <div className="container all-blogs-v2">
                    <h2>{t("product.kubernetes-monitoring.resources.title")}</h2>
                    <div className="d-flex">
                        {resources.map((item, index) => (
                            <div className="inner-block" key={index}>
                                <Link href={item.link} itemProp="url">
                                    <div className="image-wrapper">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                        />
                                    </div>
                                </Link>

                                <div>
                                    <Link href={`/blog/category/${item.category}`}>
                                        <div className="category">
                                            {item.categoryLabel}
                                        </div>
                                    </Link>

                                    <div>
                                        <Link href={item.link} itemProp="url">
                                            <h4>{item.title}</h4>
                                        </Link>

                                        <div className="date-time">
                                            {item.date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            <section className={"faq-section po-left"}>
                <div className={"container"}>
                    <h2>{t("product.kubernetes-monitoring.faq.title")}</h2>
                    <p>{t("product.kubernetes-monitoring.faq.subtitle")}</p>
                    <div className={"faq-item"}>
                        <Accordion
                            faqs={faqs.map((faq) => ({
                                ...faq,
                                answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                            }))}
                            showGroups={true}
                        />
                    </div>
                </div>
            </section>

        </>
    )
}